module.exports = __webpack_public_path__ + "static/img/6-3.a3937cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6-3.png
// module id = Buii
// module chunks = 1